// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.container[data-v-ccb1a5dc] {\r\n      margin-left: 40px;\r\n      margin-right: 40px;\n}\n.text-center[data-v-ccb1a5dc] {\r\n      text-align: center;\n}\n.text-start[data-v-ccb1a5dc] {\r\n      text-align: left;\n}\n.padding-top[data-v-ccb1a5dc] {\r\n      padding-top: 45px;\n}\n.margin-top[data-v-ccb1a5dc] {\r\n      margin-top: 45px;\n}\r\n  ", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
